<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>

    <div v-else>
      <template v-if="userId == 8">
        <vs-tabs
          alignment="fixed"
          v-model="activeTab"
          class="tab-action-btn-fill-conatiner"
        >
          <vs-tab :label="$t('setup.label.AllUserLeaves')">
            <vx-card>
              <vs-table
                :max-items="descriptionItems[0]"
                pagination
                :data="allAvailableUsers || []"
                description
                search
                :description-items="descriptionItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="list-heading">
                    {{ $t("setup.label.AllUserLeaves") }}
                  </div>
                  <div class="mr-2 mb-1 order-1">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="$router.push({ name: 'Create Leave' })"
                      size="small"
                      >{{ $t("setup.label.CreateLeave") }}</vs-button
                    >
                  </div>
                </template>
                <template slot="thead">
                  <vs-th>{{ $t("setup.label.UserName") }}</vs-th>
                  <vs-th>{{ $t("system.label.SessionDate") }}</vs-th>
                  <vs-th>{{ $t("setup.label.SessionType") }}</vs-th>
                  <!-- <vs-th>{{ $t("setup.label.LeaveType") }}</vs-th> -->
                  <!-- <vs-th>{{ $t("setup.label.Session") }}</vs-th> -->
                  <vs-th>{{ $t("setup.label.Status") }}</vs-th>
                  <vs-th class="tHeadCenter">{{
                    $t("setup.label.Actions")
                  }}</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="user"
                    v-for="(user, index) in data"
                  >
                    <vs-td :data="user.userName">{{
                      user.userName || "-"
                    }}</vs-td>
                    <vs-td :data="user.sessionDate">{{
                      getDate(user.sessionDate)
                    }}</vs-td>
                    <vs-td :data="user.sessionType">{{
                      user.sessionType
                    }}</vs-td>
                    <vs-td :data="user.status">
                      <vs-chip
                        :color="statusColor(user.status)"
                        class="availability-status"
                        >{{ user.status }}
                      </vs-chip></vs-td
                    >
                    <vs-td class="whitespace-no-wrap">
                      <div class="container_img">
                        <feather-icon
                          icon="EyeIcon"
                          :title="$t('setup.label.View')"
                          svgClasses="w-5 h-5 stroke-current cursor text-primary"
                          @click.stop="openView(user)"
                          class="icon_row"
                        />
                        <feather-icon
                          icon="EditIcon"
                          :title="$t('setup.label.Edit')"
                          svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                          @click.stop="editData(user)"
                          class="icon_row"
                        />
                        <feather-icon
                        v-if="user.status === 'LEAVE'"
                    icon="XIcon"
                    :title="$t('Cancel Leave')"
                    svgClasses="w-5 h-5 stroke-current cursor"
                    @click.stop="
                      deleteItemPopup = true;
                      delId = user.id;
                    "
                    class="icon_row"
                  />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vx-card>
            <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('Cancel User Leave')"
          :active.sync="deleteItemPopup"
          class="popup-close small-popup"
        >
          <div class="center">
            <img src="@/assets/images/pages/delete.svg" />
            <div class="success-msg">
              {{ $t("system.label.areYouSureDelete") }}
            </div>
          </div>

          <div class="center">
            <span class="p-2">
              <vs-button type="border" @click="deleteItemPopup = false">{{
                $t("system.label.cancel")
              }}</vs-button></span
            >

            <span class="p-2">
              <vs-button @click="removeTeamMapping(delId)">{{
                $t("setup.label.Ok")
              }}</vs-button>
            </span>
          </div>
          <div style="height: 20px"></div>
        </vs-popup>
      </div>
          </vs-tab>
          <vs-tab :label="$t('setup.label.MyLeaves')">
            <vx-card>
              <vs-table
                :max-items="descriptionItems[0]"
                pagination
                :data="availibilityListByUserId || []"
                description
                search
                :description-items="descriptionItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="list-heading">
                    {{ $t("setup.label.MyLeaves") }}
                  </div>
                  <div class="mr-2 mb-1 order-1">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="$router.push({ name: 'Create Leave' })"
                      size="small"
                      >{{ $t("setup.label.CreateLeave") }}</vs-button
                    >
                  </div>
                </template>
                <template slot="thead">
                  <vs-th>{{ $t("setup.label.UserName") }}</vs-th>
                  <vs-th>{{ $t("system.label.SessionDate") }}</vs-th>
                  <vs-th>{{ $t("setup.label.SessionType") }}</vs-th>
                  <!-- <vs-th>{{ $t("setup.label.LeaveType") }}</vs-th> -->
                  <!-- <vs-th>{{ $t("setup.label.Session") }}</vs-th> -->
                  <vs-th>{{ $t("setup.label.Status") }}</vs-th>
                  <vs-th class="tHeadCenter">{{
                    $t("setup.label.Action")
                  }}</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="user"
                    v-for="(user, index) in data"
                  >
                    <vs-td :data="user.userName">{{
                      user.userName || "-"
                    }}</vs-td>
                    <vs-td :data="user.sessionDate">{{
                      getDate(user.sessionDate)
                    }}</vs-td>
                    <vs-td :data="user.sessionType">{{
                      user.sessionType
                    }}</vs-td>
                    <vs-td :data="user.status">
                      <vs-chip
                        :color="statusColor(user.status)"
                        class="availability-status"
                        >{{ user.status }}
                      </vs-chip></vs-td
                    >
                    <vs-td class="whitespace-no-wrap">
                      <div class="container_img">
                        <feather-icon
                          icon="EyeIcon"
                          :title="$t('setup.label.View')"
                          svgClasses="w-5 h-5 stroke-current cursor text-primary"
                          @click.stop="openView(user)"
                          class="icon_row"
                        />
                        <feather-icon
                          icon="EditIcon"
                          :title="$t('setup.label.Edit')"
                          svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                          @click.stop="editData(user)"
                          class="icon_row"
                        />
                        <feather-icon
                        v-if="user.status === 'LEAVE'"
                    icon="XIcon"
                    :title="$t('Cancel Leave')"
                    svgClasses="w-5 h-5 stroke-current cursor"
                    @click.stop="
                      deleteItemPopup = true;
                      delId = user.id;
                    "
                    class="icon_row"
                  />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vx-card>
          </vs-tab>
        </vs-tabs>
      </template>
      <template v-else>
        <vx-card>
          <vs-table
            :max-items="descriptionItems[0]"
            pagination
            :data="availibilityListByUserId || []"
            description
            search
            :description-items="descriptionItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="list-heading">
                {{ $t("setup.label.MyLeaves") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push({ name: 'Create Leave' })"
                  size="small"
                  >{{ $t("setup.label.CreateLeave") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.UserName") }}</vs-th>
              <vs-th>{{ $t("system.label.SessionDate") }}</vs-th>
              <vs-th>{{ $t("setup.label.SessionType") }}</vs-th>
              <!-- <vs-th>{{ $t("setup.label.LeaveType") }}</vs-th> -->
              <!-- <vs-th>{{ $t("setup.label.Session") }}</vs-th> -->
              <vs-th>{{ $t("setup.label.Status") }}</vs-th>
              <vs-th class="tHeadCenter">{{ $t("setup.label.Action") }}</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="index" :data="user" v-for="(user, index) in data">
                <vs-td :data="user.userName">{{ user.userName || "-" }}</vs-td>
                <vs-td :data="user.sessionDate">{{
                  getDate(user.sessionDate)
                }}</vs-td>
                <vs-td :data="user.sessionType">{{ user.sessionType }}</vs-td>
                <vs-td :data="user.status">
                  <vs-chip
                    :color="statusColor(user.status)"
                    class="availability-status"
                    >{{ user.status }}
                  </vs-chip></vs-td
                >
                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EyeIcon"
                      :title="$t('setup.label.View')"
                      svgClasses="w-5 h-5 stroke-current cursor text-primary"
                      @click.stop="openView(user)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('setup.label.Edit')"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="editData(user)"
                      class="icon_row"
                    />
                  <feather-icon
                  v-if="user.status === 'LEAVE'"
                    icon="XIcon"
                    :title="$t('Cancel Leave')"
                    svgClasses="w-5 h-5 stroke-current cursor"
                    @click.stop="
                      deleteItemPopup = true;
                      delId = user.id;
                    "
                    class="icon_row"
                  />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </template>
    </div>
  </div>
</template>

<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      descriptionItems: [5, 10, 15],
      deleteItemPopup: false,
      userId: "",
    };
  },
  components: { AtomSpinner },
  computed: {
    ...mapState({
      allAvailableUsers: (state) => state.teams.allAvailableUsers,
      availibilityListByUserId: (state) => state.teams.availibilityListByUserId,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    getDate(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },
    getTime(time) {
      return moment(time, "HH:mm:ss").format("HH:mm:ss");
    },
    async getAvailableUsersList() {
      this.loading = true;
      try {
        await this.$store.dispatch("teams/getUserAvailabilityAction");
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
      this.loading = false;
    },
    async getAvailableUsersByUserId() {
      try {
        await this.$store.dispatch(
          "teams/getUserAvailabilityByUserIdAction",
          this.userId
        );
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
    },
    statusColor(status) {
      let color = "";
      switch (status.toUpperCase()) {
        case "BUSY":
          color = "danger";
          break;
        case "LEAVE":
          color = "warning";
          break;
        case "AVAILABLE":
          color = "primary";
          break;
        default:
          color = "black";
      }
      return color;
    },
    editData(user) {
      this.$router.push({
        name: "Edit Leave",
        params: { id: user.id, userId: user.userId },
      });
    },
    openView(e) {
      this.$router.push({
        name: "View Leave",
        params: { id: e.id },
      });
    },
    async removeTeamMapping(id) {
      try {
        await this.$store.dispatch("teams/deleteUserLeaveAction", id);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "User Leaves Successfully Canceled",
          type: "success",
        });
        this.deleteItemPopup = false;
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
  },

  async mounted() {
    const userData = sessionStorage.getItem("ngb:user");
    const user = userData ? JSON.parse(userData) : null;
    this.userId = user.userId;
    if (this.userId == 8) {
      this.getAvailableUsersList();
    }
    this.getAvailableUsersByUserId();
  },
};
</script>

<style lang="scss">
.availability-status.vs-chip-danger {
  background: #ffc2c2 !important;
  border: 1px solid #ff3838;
  color: #ff3838 !important;
}
.availability-status.vs-chip-warning {
  background: #fdf6db !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.availability-status.vs-chip-primary {
  background: #b5dafb !important;
  border: 1px solid #3c6bec;
  color: #3c6bec !important;
}
</style>
